
























































import _ from 'lodash';
import Vue from 'vue';
import { getModule } from 'vuex-module-decorators';

// tslint:disable no-var-requires
const infiniteScroll = require('vue-infinite-scroll');
// tslint:enable no-var-requires

import Batch from '@/classes/Batch';
import AddForm from '@/components/Batch/AddForm.vue';
import EditForm from '@/components/Batch/EditForm.vue';
import DatePresenter from '@/components/Misc/DatePresenter.vue';
import IdBadge from '@/components/Misc/IdBadge.vue';
import IndexPresenter from '@/components/Misc/IndexPresenter.vue';
import SearchBox from '@/components/Misc/SearchBox.vue';
import TagBadge from '@/components/Misc/TagBadge.vue';
import { IApiResponseLogin, ITag } from '@/interfaces';
import { upsertList } from '@/main';
import BatchesModule from '@/store/modules/BatchesModule';

const batchesModule = getModule(BatchesModule);

export default Vue.extend({
  components: { AddForm, DatePresenter, EditForm, IdBadge, IndexPresenter, SearchBox, TagBadge },
  directives: { infiniteScroll },
  data() {
    return {
      busy: false,
      searchBusy: false,
      isAdding: false,
      isEditing: false,
      searchText: '',
      canSearch: false,
      form: {
        editing: {
          originalCopy: new Batch(),
        },
      },
    };
  },
  computed: {
    displayBatches(): Batch[] {
      if (this.searchText !== '') {
        const batches = _.filter(batchesModule.batches, (batch: Batch) => {
          const searchText = this.searchText.toLowerCase();
          return batch.batchid.toLowerCase().includes(searchText);
        });
        return batches;
      }

      return batchesModule.batches;
    },
    hasMore(): boolean {
      return batchesModule.hasMore;
    },
  },
  methods: {
    loadMore() {
      if (this.searchText === '' && batchesModule.hasMore) {
        this.busy = true;

        batchesModule.apiLoadNextPage({ pageSize: 5 }).then(() => {
          this.busy = false;
        });
      }
    },
    addingStart() {
      this.isAdding = true;
    },
    addingCancelled() {
      this.isAdding = false;
    },
    addingSaved() {
      this.isAdding = false;
    },
    editingStart(batch: Batch) {
      this.isEditing = true;
      this.form.editing.originalCopy = batch;
    },
    editingCancelled() {
      this.isEditing = false;
    },
    editingSaved() {
      this.isEditing = false;
    },
    updateSearchText(searchText: string) {
      this.canSearch = true;
      this.searchText = searchText;
    },
    searchFromServer() {
      this.searchBusy = true;
      batchesModule.apiSearchBatches({ searchText: this.searchText }).then(() => {
        this.searchBusy = false;
        this.canSearch = false;
      });
    },
  },
});
